module.exports = __webpack_public_path__ + "img/glasses1.b0dcb7fb.png";